import React from 'react';
import PropTypes from 'prop-types';
import PrismIcon from '../icon/prismIcon';
import { FormFeedback } from '@prism/form';
import classNames from 'classnames';

class PrismErrorsContainer extends React.PureComponent {
    static propTypes = {
        errors: PropTypes.arrayOf(PropTypes.string).isRequired,
        className: PropTypes.string
    };

    render() {
        const { errors, className } = this.props;

        const feedbackClassName = classNames('prism-errors-container', className);

        return (
            <FormFeedback
                className={feedbackClassName}
                valid={false}
                invalid={true}
            >
                {errors.map((e, index) => (
                    <div key={e + index}>
                        <PrismIcon
                            className='form-feedback__icon'
                            glyph='notification-circle'
                        />
                        {e}
                    </div>
                ))}
            </FormFeedback>
        );
    }
}

export default PrismErrorsContainer;